/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SurveyMarkDto } from '../../models/survey-mark-dto';

export interface GetSurveyMark$Params {
  id: number;
}

export function getSurveyMark(
  http: HttpClient,
  rootUrl: string,
  params: GetSurveyMark$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SurveyMarkDto>> {
  const rb = new RequestBuilder(rootUrl, getSurveyMark.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyMarkDto>;
      }),
    );
}

getSurveyMark.PATH = '/surveyMarks/{id}';
